export const Colors = {
  Blue500: '#0019FF',
  Blue900: '#04093D',
  Purple200: '#8C91BD',
  Purple300: '#051392',
  Green500: '#56E788',
};
